// Client - Site key & Secret key
// export const DEV_CAPTCHA_SITE_KEY = "6Ldt4OcoAAAAAK-3gyB4nV1uBRq4T0k_IXiry1I6";
// export const DEV_CAPTCHA_SECRET_KEY =
//   "6Ldt4OcoAAAAAOw-khSm3_D6sVaGc-kjp0CHyyc9";
// dev & prod key as well
export const DEV_CAPTCHA_SITE_KEY = "6LdXrAIpAAAAABnoFmLf6sycrfPAcIkRnOaG1XbC";
export const DEV_CAPTCHA_SECRET_KEY =
  "6LdXrAIpAAAAADmZ-MUiaNzKX4cNCcIt1Z42osqf";
// Gayathri own
// export const DEV_CAPTCHA_SITE_KEY = "6LdxDUwpAAAAAE1Yrf-bQcsSgft8GiA0PMsVKluM";
// export const DEV_CAPTCHA_SECRET_KEY =
//   "6LdxDUwpAAAAACx6C8ngutJrE26DSnnwvlwYxuRn";
// Own
// export const DEV_CAPTCHA_SITE_KEY = '6Ldym-IoAAAAAJg96HvxuotRLQbJTmB10ZLxYoIu';
// export const DEV_CAPTCHA_SECRET_KEY =
//   '6Ldym-IoAAAAAEsU0jFweG9zJ2tVE2Mp5ksLlxBr';
// export const DEV_CAPTCHA_SITE_KEY = '6Lcf4u8oAAAAAGDxVXEutcpEOJXMpVeZIw7eowuS';
// export const DEV_CAPTCHA_SECRET_KEY =
//   '6Lcf4u8oAAAAAMWEeuCSxIK6sJo5rjGMkpcbfODU';
// work localhost also
// export const DEV_CAPTCHA_SITE_KEY = '6LcoRfAoAAAAAKM-zvGbHMjJ01bWMGNFDZJaLqsA';
// export const DEV_CAPTCHA_SECRET_KEY =
//   '6LcoRfAoAAAAAB_ERDV5eo9pP94dlW2_ZVo7v4Qd';
